// Webpack Imports
import { Modal } from 'bootstrap';

var $ = jQuery.noConflict();

// Sticking class on scroll
const primaryHeader = document.querySelector(".primary-header");
const scrollWatcher = document.createElement("div");

scrollWatcher.setAttribute("data-scroll-watcher", "");
primaryHeader.before(scrollWatcher);

const navObserver = new IntersectionObserver(
  (entries) => {
    primaryHeader.classList.toggle("sticking", !entries[0].isIntersecting);
  },
  { rootMargin: "50px 0px 0px 0px" }
);

navObserver.observe(scrollWatcher);

// Modale du moteur de recherche
var modaleRecherche = new Modal(document.getElementById('portRecherche'));
var lastFocus;

$('.search-toggler').on('click', function() {
	modaleRecherche.show();
	lastFocus = $(':focus');
});
$('.search-close').on('click', function() {
	modaleRecherche.hide();
	if(lastFocus)
        lastFocus.focus();
})	

// Divers
$(document).on('ready', function() {
  $('a.wp-block-button__link').attr('role', 'button');
});
